export const ACCOUNT_ENDPOINT =  'api/account';
export const CURRENT_COLLABORATOR_ENDPOINT =  '/collaboratorjava/api/current-collaborator';


export const LOGIN_ENDPOINT = 'api/authenticate';
export const PASSWORD_RESET_ENDPOINT = 'api/account/reset-password/finish';
export const PASSWORD_REQUEST_ENDPOINT = 'api/account/reset-password/init';
export const CHANGE_PASSWORD_ENDPOINT =  'api/account/change-password';
